<div class="bk-page cd">
  <!-- feedback cards  -->
  <feedback-card feedBackType="error" [message]="campaignsService.errorMsg"></feedback-card>
  <feedback-card feedBackType="success" [message]="successMessage"></feedback-card>

  <!-- Persistent, so screen readers hear the change -->
  <span class="bk-sr-only" role="status">{{ loadState === "loading" ? "Loading campaign" : "" }}</span>

  <a class="cd__crumb" routerLink="/organization/campaigns">
    <span class="bk-sym" aria-hidden="true">arrow_back</span>
    Campaigns
  </a>

  @if (loadState === "error") {
    <!-- The campaign itself could not be read -->
    <section class="bk-panel cd__error" role="alert">
      <span class="bk-sym cd__error-icon" aria-hidden="true">campaign</span>
      <h1 class="bk-heading cd__error-title">This campaign could not be loaded</h1>
      <p class="cd__error-body">
        It may have been deleted, or the link may be incomplete. Check your
        connection and try again.
      </p>
      <div class="cd__error-actions">
        <a class="bk-btn bk-btn--ghost" routerLink="/organization/campaigns">Back to campaigns</a>
        <button type="button" class="bk-btn bk-btn--primary" (click)="retry()">Try again</button>
      </div>
    </section>
  } @else {
    <!-- Name, status and run window, with what can be done to the campaign -->
    <header class="bk-page__head cd__head">
      <div class="bk-page__intro">
        <p class="bk-eyebrow">Campaign</p>
        @if (loadState === "loading") {
          <div class="cd__title-skel" aria-hidden="true">
            <span class="bk-skel" style="width: min(420px, 80%); height: 32px"></span>
            <span class="bk-skel" style="width: min(300px, 60%); height: 14px"></span>
          </div>
        } @else {
          <h1 class="bk-page__title">{{ name }}</h1>
          <p class="cd__meta">
            @if (campaign.status) {
              <app-status [text]="campaign.status" [status]="campaign.status" />
            }
            @if (window) {
              <span>{{ window }}</span>
            }
            @if (created) {
              <span>{{ created }}</span>
            }
          </p>
          @if (description) {
            <p class="bk-page__sub cd__desc">{{ description }}</p>
          }
        }
      </div>

      <div class="bk-page__actions cd__actions">
        <ng-container *hasPermission="{ category: 'CAMPAIGN_MANAGEMENT', permission: 'edit-campaigns' }">
          <button
            type="button"
            class="bk-btn bk-btn--ghost"
            [disabled]="loadState !== 'ready'"
            (click)="showEdit = true"
          >
            <span class="bk-sym" aria-hidden="true">edit</span>
            Edit details
          </button>
        </ng-container>
        <ng-container *hasPermission="{ category: 'CAMPAIGN_MANAGEMENT', permission: 'delete-campaigns' }">
          <button
            type="button"
            class="bk-icon-btn cd__delete"
            aria-label="Delete campaign"
            matTooltip="Delete campaign"
            [disabled]="loadState !== 'ready'"
            (click)="showDelete = true"
          >
            <span class="bk-sym" aria-hidden="true">delete</span>
          </button>
        </ng-container>
      </div>
    </header>

    <!-- tabs -->
    <nav class="cd__tabs" aria-label="Campaign sections">
      <app-routing-tab [tabList]="tabs" />
    </nav>

    <router-outlet></router-outlet>
  }

  <!-- edit popup -->
  @if (showEdit) {
    <app-edit-campaign-details
      [openModal]="showEdit"
      (onClose)="showEdit = false"
      [campaignData]="campaign"
    ></app-edit-campaign-details>
  }

  <!-- delete popup -->
  @if (showDelete) {
    <app-prompt-card
      [openModal]="showDelete"
      title="Delete campaign"
      buttonText="Delete campaign"
      tone="danger"
      (onClose)="showDelete = false"
      (onButtonClick)="deleteCampaign()"
      [loading]="campaignsService.isLoading"
      closeText="Keep campaign"
    >
      <p class="cd__prompt">
        Delete <strong>{{ name }}</strong> permanently? This cannot be undone.
      </p>
    </app-prompt-card>
  }
</div>
